import type { ReactNode } from "react";

import { Card } from "#/components/ui/card";
import { cn } from "#/lib/utils";

const promoCardClassName =
  "relative w-full overflow-hidden border-premium/60 bg-card shadow-2xl shadow-premium/20 ring-2 ring-premium/70";

export function PromoCardBackground() {
  return (
    <>
      <div
        className="pointer-events-none absolute inset-0 bg-linear-to-br from-premium/30 via-premium/12 to-card"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -top-20 left-1/2 h-40 w-80 -translate-x-1/2 rounded-full bg-premium/30 blur-3xl"
        aria-hidden
      />
    </>
  );
}

export function PromoCardShell({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <Card size="default" className={cn(promoCardClassName, className)}>
      <PromoCardBackground />
      {children}
    </Card>
  );
}
